import React, { useState, useEffect } from 'react';
import { collectionGroup, query, where, onSnapshot, getDoc, doc, updateDoc } from 'firebase/firestore';

const TasksInboxView = ({ db, sellerFilter, onSelectLead }) => {
    const [tasks, setTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        const q = query(collectionGroup(db, 'timeline'), where('type', '==', 'task'));

        const unsubscribe = onSnapshot(q, async (snapshot) => {
            const tasksData = await Promise.all(snapshot.docs.map(async (docSnap) => {
                const task = { id: docSnap.id, ...docSnap.data() };
                const leadRef = docSnap.ref.parent.parent;
                if (leadRef) {
                    const leadSnap = await getDoc(leadRef);
                    if (leadSnap.exists()) {
                        task.lead = { id: leadSnap.id, ...leadSnap.data() };
                    }
                }
                return task;
            }));

            const filteredTasks = (sellerFilter === 'all') 
                ? tasksData 
                : tasksData.filter(t => t.lead?.sellerId === sellerFilter);
            
            setTasks(filteredTasks.sort((a,b) => (b.timestamp?.toMillis() || 0) - (a.timestamp?.toMillis() || 0)));
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [db, sellerFilter]);

    const toggleTaskStatus = async (task) => {
        if (!task.lead) return;
        const newStatus = task.status === 'pendiente' ? 'completado' : 'pendiente';
        const itemRef = doc(db, `tradeshow_leads/${task.lead.id}/timeline`, task.id);
        await updateDoc(itemRef, { status: newStatus });
    };

    if (isLoading) return <div className="text-center p-8">Cargando tareas...</div>;

    return (
        <div className="bg-white p-4 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Bandeja de Tareas y Solicitudes</h2>
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-left text-gray-600">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th className="px-4 py-2">Estado</th>
                            <th className="px-4 py-2">Tarea</th>
                            <th className="px-4 py-2">Lead</th>
                            <th className="px-4 py-2">Vendedor</th>
                            <th className="px-4 py-2">Fecha</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map(task => (
                            <tr key={task.id} className="bg-white border-b hover:bg-gray-50">
                                <td className="px-4 py-2"><input type="checkbox" checked={task.status === 'completado'} onChange={() => toggleTaskStatus(task)} /></td>
                                <td className="px-4 py-2">{task.text}</td>
                                <td className="px-4 py-2"><button onClick={() => onSelectLead(task.lead)} className="text-blue-600 hover:underline">{task.lead?.contactName}</button></td>
                                <td className="px-4 py-2">{task.lead?.sellerName}</td>
                                <td className="px-4 py-2">{task.timestamp?.toDate().toLocaleDateString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TasksInboxView;

